import type { IconSvgObject } from './types';

const Radar02Icon: IconSvgObject = [
  ["path", { d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C12.9401 6 13.8296 6.21619 14.6217 6.60156C15.3346 6.94843 15.6911 7.12186 15.7764 7.63009C15.8617 8.13832 15.5173 8.48274 14.8284 9.17157L12 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Radar02Icon;
